module.exports = __webpack_public_path__ + "img/image28.6e92479e.jpg";